import { Button, Card, Stack, Typography } from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import { useState, useCallback } from "react";
import DialogComponent from '../../components/dialog/dialogComponent';
import { GetAuth } from "../../context/auth/authProvider";
import { useNavigate } from "react-router-dom";

const ProfileLogout = ({ width='100%' }) => {
    const [showDialog, setShowDialog] = useState(false);
    const auth = GetAuth();
    const navigate = useNavigate();

    const logoutRequest = useCallback(() => {
        setShowDialog(true);
    }, []);

    const confirmLogout = useCallback(async () => {
        setShowDialog(false);
        await auth.logOut();
        navigate('/login');
    }, [auth, navigate]);

    const cancelLogout = useCallback(() => {
        setShowDialog(false);
    }, []);

    return (
        <>
            <Button fullWidth disableRipple sx={{ backgroundColor: 'white', p: 0 }} onClick={logoutRequest}>
                <Card sx={{ width: width }}>
                    <Stack direction='row' justifyContent='start' alignItems='center' width='100%' sx={{ py: 2, px: {xs: 2.5, md: 4, lg: 10} }}>
                        <LogoutIcon sx={{ width: {xs: 22, md: 32, lg: 40}, height: {xs: 22, md: 32, lg: 40}, color: {xs: 'black', md: '#FF0000'} }} />
                        <Typography fontWeight={400} fontSize={{xs: 14, md: 16, lg: 22}} letterSpacing={0.3} color="#121212" sx={{ pl: {xs: 4, md: 4, lg: 9} }}>
                            Logout
                        </Typography>
                    </Stack>
                </Card>
            </Button>

            <DialogComponent 
                open={showDialog}
                title="Logout"
                body={
                    <Stack direction='column' justifyContent='center' alignItems='center'>
                        <Typography fontWeight={300} fontSize={14} textAlign='justify'>
                            Are you sure to logout from the system?
                        </Typography>
                    </Stack>
                }
                handleClose={cancelLogout}
                proceedText="No"
                cancelText="Yes"
                proceedCallback={cancelLogout}
                cancelCallback={confirmLogout}
            />
        </>
    );
}

export default ProfileLogout;
